import { Model } from '@vuex-orm/core';

import http from '@/services/http';

export default class OrderRule extends Model {
  static entity = 'orderRules';

  static primaryKey = 'id';

  // FIELDS //////////////////////
  static fields() {
    return {
      id: this.attr(null),
      isActive: this.attr(false),
      merchantId: this.attr(null),
      minutesToAdd: this.attr(null),
      priority: this.attr(null),
      ruleSegments: this.attr([]),
      storeId: this.attr(null)
    };
  }

  // STATE //////////////////////
  static state() {
    return {
      fetching: false,
      creating: false,
      updating: false,
      deleting: false
    };
  }

  static $state() {
    return this.store().state.entities.orderRules;
  }

  // ACTIONS //////////////////////
  static async fetchOrderRules(storeId = null) {
    try {
      this.commit((state) => {
        state.fetching = true;
      });

      const merchantId = this.store().state.entities.merchants.selectedMerchantId;

      let url = `merchants/${merchantId}/order_rules`;
      if (storeId) {
        url += `?store_id=${storeId}`;
      }

      const { data } = await http.get(url);

      this.insert({ data: data.orderRules });

      return data;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.fetching = false;
      });
    }
  }

  static async fetchOrderRule(id) {
    try {
      this.commit((state) => {
        state.fetching = true;
      });

      const { data } = await http.get(`order_rules/${id}`);

      this.insert({ data: data.orderRule });

      return data;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.fetching = false;
      });
    }
  }

  static async createOrderRule(orderRule) {
    try {
      this.commit((state) => {
        state.creating = true;
      });

      const merchantId = this.store().state.entities.merchants.selectedMerchantId;

      const { data } = await http.post(`merchants/${merchantId}/order_rules`, {
        order_rule: orderRule
      });

      this.insert({ data: data.orderRule });

      return data;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.creating = false;
      });
    }
  }

  static async updateOrderRule(orderRule) {
    try {
      this.commit((state) => {
        state.updating = true;
      });

      const { data } = await http.put(`order_rules/${orderRule.id}`, {
        order_rule: orderRule
      });

      return this.update({
        where: orderRule.id,
        data: data.orderRule
      });
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.updating = false;
      });
    }
  }

  static async deleteOrderRule(id) {
    try {
      this.commit((state) => {
        state.deleting = true;
      });

      await http.delete(`order_rules/${id}`);

      return this.delete(id);
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.deleting = false;
      });
    }
  }
}
